//验证 URL
export function isUrl(value) {
  const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
  return reg.test(value)
}

//验证手机
export function isPhone(value) {
  const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
  return reg.test(value)
}

//验证输入是否为空
export function isEmpty(value) {
  return value.trim().length === 0
}